import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import NewsArticleSummary from './NewsArticleSummary';

class NewsArticleCard extends Component {

  static propTypes = {
    media: PropTypes.string.required,
    title: PropTypes.string,
    dateString: PropTypes.string,
    to: PropTypes.string,
    excerpt: PropTypes.string,

  };
  static defaultProps = {
    title: "title",
    dateString: "dateString",
    to: "/",
    excerpt: "excerpt",
  };

  render() {
    const {media, title, dateString, to, excerpt} = this.props
    return (
      <div className="related-news-card">
        <div className="row">
          <div className="col-xl-12 col-lg-6 col-md-12">
            <div className="img-wrapper">
              <img alt="related-news-article-img" src={media} />
            </div>
          </div> 
          <div className="col-xl-12 col-lg-6 col-md-12">
            <NewsArticleSummary title={title} dateString={dateString} excerpt={excerpt} to={to} />
          </div>
        </div>
      </div>
    );
  }
}

export default NewsArticleCard;


// WEBPACK FOOTER //
// ./src/components/NewsArticleCard.js